export default "__VITE_ASSET__DG3XqurA__"